import Cookies from 'js-cookie';

export const isCookiesConsented = () => {
    const cookie = Cookies.get('rejectCookie');
    return !cookie || cookie === 'false';
}